import * as rasterizeHTML from 'rasterizehtml'

export class HtmlRasterizer {

	/**
	 * Renders HTML into an offscreen canvas of the given pixel size.
	 * Caller is responsible for removing the returned canvas once done with it.
	 *
	 * @param {*} html Full HTML document string
	 * @param {*} canvasWidth
	 * @param {*} canvasHeight
	 * @returns Promise resolving to the rendered canvas
	 */
	static renderToCanvas = (html, canvasWidth, canvasHeight) => {
		const canvas = document.createElement('canvas')
		canvas.width = canvasWidth
		canvas.height = canvasHeight
		return rasterizeHTML.drawHTML(html, canvas)
			.then(() => canvas)
	}

}
